import request from "@/utils/request";

// 谈判人可跟单list
export function listPendingClue(param) {
  return request({
    url: "/api/mts-api/bizOppor/tprPendingFollowList",
    method: "get",
    params: param,
  });
}

// 商务可跟单list
export function swPendingFollowList(param) {
  return request({
    url: "/api/mts-api/bizOppor/swPendingFollowList",
    method: "get",
    params: param,
  });
}

// 跟单
export function followUp(data) {
  return request({
    url: "/api/mts-api/bizOppor/followUp",
    method: "post",
    data: data,
  });
}
// 跟单
export function blockBizOpporMsg(data) {
  return request({
    url: "/api/mts-api/bizOppor/blockBizOpporMsg",
    method: "post",
    data: data,
  });
}
// 屏蔽接单
export function blockBusiness(data) {
  return request({
    url: "/api/mts-api/user/blockBusiness",
    method: "post",
    data: data,
  });
}
